import React, { ReactElement } from 'react'
// Externals imports.
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress'
// CSS imports. Commented out because of current build process.
// import './loader.scss';

/**
 * Basic loader component.
 *
 */
const Loader: React.FC<CircularProgressProps> = (props?: CircularProgressProps): ReactElement => (
    <div className='loader'>
        <CircularProgress {...props} />
    </div>
)

export default Loader
